<template>
  <div class="ibox form-page animated fadeInRightBig">
    <div class="ibox-title form-page__header">
      <div class="form-page__title-wrap">
        <h5 class="form-page__title">
          <i class="fa fa-cog form-page__title-icon"></i>
          Configurações
        </h5>
        <p class="form-page__subtitle">Alterações são salvas automaticamente</p>
      </div>
    </div>
    <div class="ibox-content form-page__body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group form-page__field">
            <label class="form-page__label">
              Permitir assinar documentos expirados?
            </label>
            <select
              v-model="settings.can_sign_expired_documents"
              class="form-control"
              @change="changed('can_sign_expired_documents')"
            >
              <option :value="0">Não</option>
              <option :value="1">Sim</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group form-page__field">
            <label class="form-page__label">
              Enviar e-mails para os supervisores das unidades sobre os documentos expirados?
            </label>
            <select
              v-model="settings.send_emails_about_expired_documents"
              class="form-control"
              @change="changed('send_emails_about_expired_documents')"
            >
              <option :value="0">Não</option>
              <option :value="1">Sim</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settings: {
        can_sign_expired_documents: false,
        send_emails_about_expired_documents: false
      }
    };
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    changed(what) {
      const self = this;
      const api = self.$store.getters.api + "settings/";
      const fd = new FormData();
      fd.append(what, self.settings[what]);

      self.$http
        .post(api, fd)
        .then(() => {
          self.$message("Sucesso", "Dado salvo com sucesso", "success");
        })
        .catch(error => {
          const errors =
            (error.response && error.response.data) || "Erro ao salvar";
          self.$message(null, errors, "error");
        });
    },
    getSettings() {
      const self = this;
      const api = self.$store.getters.api + "settings/my-settings";

      self.$http.get(api).then(response => {
        self.settings = response.data;
      });
    }
  }
};</script>



// WEBPACK FOOTER //
// src/components/Settings/Settings.vue